import { Formik, Form, ErrorMessage } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import InputCom from "src/components/Common/Input";
import * as Yup from "yup";
import { ROUTER } from "src/constants/routes";
import Button from "src/components/UI/Button";
import { FieldModal } from "src/models/components/inputWrapperModel";
import { useDispatch, useSelector } from "react-redux";
import { RootReducerState } from "src/store/reducers";
import { useToast } from "src/components/Common/ReactToaster";
import ValidationPopup from "src/components/Common/ValidationMessage/ValidationPopup";
import MultiSelector from "src/components/Common/MultiSelector";
import ErrorText from "src/components/UI/ErrorText";
import { clearWhatsappMessageMessage, createWhatsappMessage, getCustomerNumList, getDealerNumList, getEmployeeNumList, getFranchiseNumList, getSupplierNumList, getWhatsappPrefixList, getWhatsappNumbersByPrefix, getManufacturerNumList } from "src/store/WhatsApp/action";
import DropdownInput from "src/components/UI/DropdownInput";
import CheckboxInput from "src/components/UI/CheckboxInput";
import { Dialog } from "primereact/dialog";
import { Calendar } from "primereact/calendar";

import FeatherIcon from "feather-icons-react";
import MarketingBreadcrumb from "../MarketingBreadcrumb";
import { API } from "src/util/api";

const SendWhatsAppMessage: React.FC = () => {
  const [uploadFiles, setUploadFiles] = useState<any>([]);
  const [localFormFields, setLocalFormFields] = useState<FieldModal[]>([]);
  const [imagePreviewUrl, setImagePreviewUrl] = useState<string>("");
  const [mediaType, setMediaType] = useState<"image" | "video" | "">("");
  const imageInputRef = useRef<HTMLInputElement>(null);
  const [visible, setVisible] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const setFieldValueRef = useRef<any>(null);
  const { id } = useParams();
  const { showToast } = useToast();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const validateMobileNumbers = (array: any) => {
    const mobileNumberRegex = /^\+?\d{10,}$/;
    return allMobileNum.every((mobileNumber: any) => {
      if (!mobileNumber.phone) return true;
      return mobileNumberRegex.test(mobileNumber.phone)
    });
  };

  const validationSchema = Yup.object().shape({
    toUserTypes: Yup.array().of(Yup.string()).min(1, "At least one user type must be selected")
      .required("User type is required"),
    textContent: Yup.string().required("Chat content is required").max(1024, "Chat content should be less than 1024 characters"),
    allMobileNumber: Yup.array()
      .test('is-empty', 'Mobile Number is required', () => {
        return allMobileNum.length > 0;
      })
      .test('is-valid-mobile-numbers', 'All should be valid mobile numbers', (array) => {
        return validateMobileNumbers(array);
      })
    // .test('max-recipients', 'Maximum 1000 recipients allowed', () => {
    //   return allMobileNum.length <= 1000;
    // }),
  });

  const { error, message, loading, employeeNum, dealerNum, customerNum, franchiseNum, supplierNum, manufacturerNum, prefixList, prefixNumbers } = useSelector((state: RootReducerState) => state.WhatsappReducer);
  const initialValue: any = {
    toUserTypes: [],
    allMobileNumber: [],
    textContent: "",
    scheduledSendTime: null,
    sendAll: false
  };

  useEffect(() => {
    if (error) {
      setVisible(true);
      setIsSubmitting(false);
    }
    if (message) {
      showToast(message, { type: "success" });
      dispatch(clearWhatsappMessageMessage())
      setTimeout(() => {
        setIsSubmitting(false);
        navigate(ROUTER.WHATSAPP_MESSAGE_LIST);
      }, 500);
    }
  }, [error, message]);

  useEffect(() => {
    const preloader: any = document.getElementById("preloader");
    if (loading) {
      preloader.style.display = "block";
    } else {
      preloader.style.display = "none";
    }
  }, [loading]);

  const hidePopup = () => {
    setVisible(false);
    dispatch(clearWhatsappMessageMessage());
  };

  const dialogContainer = (error: any) => {
    return (
      <>
        <ValidationPopup error={error} visible={visible} onHide={hidePopup} />
      </>
    );
  };

  const handleSubmit = (values: any) => {
    setIsSubmitting(true);
    let num = allMobileNum?.map((numbers: any) => numbers.phone);
    let formattedTextContent = values?.textContent?.replace(/\r/g, '');
    formattedTextContent = formattedTextContent?.replace(/\n/g, '\\n');
    formattedTextContent = formattedTextContent?.replace(/ {4,}/g, ' ');

    let formatted = {
      id: 0,
      textContent: formattedTextContent,
      toUserTypes: values.toUserTypes.length > 0 ? values.toUserTypes : null,
      allMobileNumber: num,
      issendFile: uploadFiles.length > 0,
      uploadFiles: uploadFiles.length > 0 ? uploadFiles : null,
      scheduledSendTime: values.scheduledSendTime || null,
    };

    dispatch(createWhatsappMessage(formatted));
  };


  const handleReset = (resetForm: any) => {
    resetForm(getEmptyInitialValues());
    setUploadFiles([]);
    setImagePreviewUrl("");
    setMediaType("");
    setIsSubmitting(false);
    if (imageInputRef.current) {
      imageInputRef.current.value = "";
    }
  };

  const getEmptyInitialValues = () => {
    const initialValue = localFormFields?.reduce((acc: any, field: any) => {
      if (field.type !== "checkbox") {
        acc[field.name] = "";
      } else {
        acc[field.name] = false;
      }
      return acc;
    }, {});
    return initialValue;
  };

  const toUserTypes = [
    { label: "Employee", value: "Employee" },
    { label: "Dealer", value: "Dealer" },
    { label: "Customer", value: "Customer" },
    { label: "New Customer", value: "New Customer" },
    { label: "Franchise", value: "Franchise" },
    { label: "Supplier", value: "Supplier" },
    { label: "Manufacturer", value: "Manufacturer" },
    { label: "Others", value: "Others" },
  ];

  const [newCustomerNum, setNewCustomerNum] = useState<any[]>([]);

  useEffect(() => {
    dispatch(getEmployeeNumList())
    dispatch(getDealerNumList())
    dispatch(getCustomerNumList())
    dispatch(getFranchiseNumList())
    dispatch(getSupplierNumList())
    dispatch(getManufacturerNumList())
    dispatch(getWhatsappPrefixList())

    API.getUnusedCustomerDropdownListApi()
      .then((res: any) => {
        if (res && res.data) {
          const formatted = res.data.map((item: any) => ({
            name: item.name || "",
            phone: item.phoneNumber || ""
          }));
          setNewCustomerNum(formatted);
        }
      })
      .catch((err: any) => {
        console.error("Error fetching unused customer dropdown list:", err);
      });

    return () => {
      dispatch(clearWhatsappMessageMessage())
    }
  }, [])
  const [allMobileNum, setAllMobilenum] = useState<any>([]);
  const [jobPrefix, setJobPrefix] = useState("");
  const [showScheduleDialog, setShowScheduleDialog] = useState(false);
  const [tempScheduledTime, setTempScheduledTime] = useState<string>("");
  
  const handleSelect = (selectedOptions: any, setFieldValue: any, sendAllVal = false) => {
    setFieldValue('toUserTypes', selectedOptions);
    setFieldValue('jobPrefix', "");
    setJobPrefix("");
    // If only Dealer/Customer/Manufacturer is selected AND sendAll is false, wait for prefix selection
    if (
      selectedOptions.length === 1 &&
      ["Dealer", "Customer", "Manufacturer"].includes(selectedOptions[0]) &&
      !sendAllVal
    ) {
      setAllMobilenum([]);
      setFieldValue("allMobileNumber", []);
      return;
    }
    // Otherwise, bind numbers directly
    const updatedPhoneNum = [];
    if (selectedOptions.includes("Employee")) {
      updatedPhoneNum.push(...(employeeNum || []));
    }
    if (selectedOptions.includes("Dealer")) {
      updatedPhoneNum.push(...(dealerNum || []));
    }
    if (selectedOptions.includes("Customer")) {
      updatedPhoneNum.push(...(customerNum || []));
    }
    if (selectedOptions.includes("New Customer")) {
      updatedPhoneNum.push(...(newCustomerNum || []));
    }
    if (selectedOptions.includes("Franchise")) {
      updatedPhoneNum.push(...(franchiseNum || []));
    }
    if (selectedOptions.includes("Supplier")) {
      updatedPhoneNum.push(...(supplierNum || []));
    }
    if (selectedOptions.includes("Manufacturer")) {
      updatedPhoneNum.push(...(manufacturerNum || []));
    }
    setFieldValue("allMobileNumber", updatedPhoneNum?.filter((item: any) => item.phone));
    setAllMobilenum(updatedPhoneNum);
  };

  // Handle Send All checkbox toggle
  const handleSendAllChange = (checked: boolean, values: any, setFieldValue: any) => {
    setFieldValue('sendAll', checked);
    if (checked) {
      setFieldValue('jobPrefix', "");
      setJobPrefix("");
      const selectedOptions = values.toUserTypes || [];
      const updatedPhoneNum = [];
      if (selectedOptions.includes("Employee")) {
        updatedPhoneNum.push(...(employeeNum || []));
      }
      if (selectedOptions.includes("Dealer")) {
        updatedPhoneNum.push(...(dealerNum || []));
      }
      if (selectedOptions.includes("Customer")) {
        updatedPhoneNum.push(...(customerNum || []));
      }
      if (selectedOptions.includes("New Customer")) {
        updatedPhoneNum.push(...(newCustomerNum || []));
      }
      if (selectedOptions.includes("Franchise")) {
        updatedPhoneNum.push(...(franchiseNum || []));
      }
      if (selectedOptions.includes("Supplier")) {
        updatedPhoneNum.push(...(supplierNum || []));
      }
      if (selectedOptions.includes("Manufacturer")) {
        updatedPhoneNum.push(...(manufacturerNum || []));
      }
      setFieldValue("allMobileNumber", updatedPhoneNum?.filter((item: any) => item.phone));
      setAllMobilenum(updatedPhoneNum);
    } else {
      // If unchecked and only Dealer/Customer/Manufacturer is selected, clear numbers and wait for prefix
      if (
        values.toUserTypes.length === 1 &&
        ["Dealer", "Customer", "Manufacturer"].includes(values.toUserTypes[0])
      ) {
        setAllMobilenum([]);
        setFieldValue("allMobileNumber", []);
      }
    }
  };

  // Handle prefix change
  const handlePrefixChange = (e: any, values: any, setFieldValue: any) => {
    setJobPrefix(e.value);
    setFieldValue('jobPrefix', e.value);
    if (values.toUserTypes.length === 1 && ["Dealer", "Customer", "Manufacturer"].includes(values.toUserTypes[0])) {
      dispatch(getWhatsappNumbersByPrefix({ userType: values.toUserTypes[0], jobPrefix: e.value }));
    }
  };

  // When prefixNumbers change, update chips
  useEffect(() => {
    if (prefixNumbers && prefixNumbers.length > 0) {
      setAllMobilenum(prefixNumbers);
      if (setFieldValueRef.current) {
        setFieldValueRef.current("allMobileNumber", prefixNumbers);
      }
    }
  }, [prefixNumbers]);


  const handleImageSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const type = file.type.startsWith("video/") ? "video" : "image";
      setMediaType(type);
      setUploadFiles([file]);
      setImagePreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleMediaDrop = (file: File) => {
    const isImage = file.type.startsWith("image/");
    const isVideo = file.type.startsWith("video/");
    if (isImage || isVideo) {
      setMediaType(isVideo ? "video" : "image");
      setUploadFiles([file]);
      setImagePreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleImageRemove = () => {
    setUploadFiles([]);
    setImagePreviewUrl("");
    setMediaType("");
    if (imageInputRef.current) {
      imageInputRef.current.value = "";
    }
  };

  const [text, setText] = useState<any>("")
  const [filter, setFilter] = useState('');
  const [showAddInput, setShowAddInput] = useState(false);
  const [showContactsDialog, setShowContactsDialog] = useState(false);
  const [contactsSearch, setContactsSearch] = useState("");

  const handleRemoveParts = (id: number, setFieldValue: any) => {
    const RemoveParts = allMobileNum.filter(
      (item: any, index: number) => index !== id
    );
    setAllMobilenum(RemoveParts);
    setFieldValue("allMobileNumber", RemoveParts);
  };
  const handleMobileAdd = (event: any, setFieldValue: any) => {
    if (event.key == "Enter" || event.key == "Tab") {
      event.preventDefault()
      const newPhone = event.target.value.trim();
      if (newPhone) {
        const updated = [...allMobileNum, { name: "", phone: newPhone }];
        setAllMobilenum(updated);
        setFieldValue("allMobileNumber", updated);
      }
      setText("")
    }
  };
  const handleClearAll = (setFieldValue: any) => {
    setAllMobilenum([]);
    setFieldValue("allMobileNumber", []);
  };
  return (
    <React.Fragment>
      {visible && dialogContainer(error)}

      <div className="page-content" id="view-brand">
        <Container fluid>
          <MarketingBreadcrumb
            title="WhatsApp Message List"
            titlePath={ROUTER.WHATSAPP_MESSAGE_LIST}
            breadcrumbItem={id ? `Edit Chat` : `New Chat`}
            filter={filter}
            setFilter={setFilter}
          />
          <Row id="email">
            <Card>
              <CardBody>
                <React.Fragment>
                  <Formik
                    onSubmit={handleSubmit}
                    initialValues={initialValue}
                    validationSchema={validationSchema}
                    enableReinitialize
                  >
                    {({
                      values,
                      handleChange,
                      touched,
                      errors,
                      handleBlur,
                      resetForm,
                      reset,
                      setFieldValue,
                      submitForm,
                      ...rest
                    }: any) => {
                      setFieldValueRef.current = setFieldValue;
                      return (
                        <Form onChange={handleChange}>
                          <Row>
                            <Col lg={3} className="mb-2">
                              <MultiSelector
                                name="toUserTypes"
                                label="User Types"
                                options={toUserTypes}
                                optionLabel="label"
                                id="toUserTypes"
                                labelClassName="form-Label"
                                onBlur={handleBlur("toUserTypes")}
                                value={values.toUserTypes}
                                onChange={(e: any) => { handleSelect(e.target.value, setFieldValue, values.sendAll) }}
                                isRequired={true}
                                invalid={
                                  touched["toUserTypes"] && errors["toUserTypes"]
                                    ? true
                                    : false
                                }
                              />
                            </Col>

                            {/* Send to All checkbox & Prefix Dropdown for Customer/Dealer/Manufacturer */}
                            {values.toUserTypes.length === 1 && (values.toUserTypes.includes("Customer") || values.toUserTypes.includes("Dealer") || values.toUserTypes.includes("Manufacturer")) && (
                              <>
                                <Col xs="auto">
                                  <CheckboxInput
                                    name="sendAll"
                                    label="Send to All"
                                    className="mt-4 pt-1"
                                    value={values.sendAll}
                                    onChange={(e: any) => {
                                      if (e.originalEvent) {
                                        e.originalEvent.stopPropagation();
                                      }
                                      handleSendAllChange(e.checked, values, setFieldValue);
                                    }}
                                  />
                                </Col>

                                <Col lg={4} className="mt-2">
                                  <DropdownInput
                                    options={prefixList?.map((data: any) => ({ label: data.jobPrefix, value: data.jobPrefix })) || []}
                                    name="jobPrefix"
                                    label="Job Prefix"
                                    onChange={(e: any) => handlePrefixChange(e, values, setFieldValue)}
                                    required={false}
                                    value={jobPrefix}
                                    onBlur={handleBlur}
                                    disabled={values.sendAll || values.toUserTypes.length > 1}
                                    invalid={false}
                                  />
                                  {values.toUserTypes.length > 1 && <p>To select prefix there should be only one User Type</p>}
                                </Col>
                              </>
                            )}

                            <Row className="mt-2">
                              {/* Left: Media picker + Chat content */}
                              <Col lg={7}>
                                <label className="form-Label">Image / Video</label>
                                <div
                                  style={{
                                    border: "2px dashed #d1d5db",
                                    borderRadius: "10px",
                                    padding: "16px",
                                    textAlign: "center",
                                    background: "#fafbfc",
                                    marginBottom: "12px",
                                    cursor: imagePreviewUrl ? "default" : "pointer",
                                    transition: "border-color 0.2s",
                                  }}
                                  onClick={() => !imagePreviewUrl && imageInputRef.current?.click()}
                                  onDragOver={(e) => e.preventDefault()}
                                  onDrop={(e) => {
                                    e.preventDefault();
                                    const file = e.dataTransfer.files?.[0];
                                    if (file) handleMediaDrop(file);
                                  }}
                                >
                                  {imagePreviewUrl ? (
                                    <div style={{ position: "relative", display: "inline-block" }}>
                                      {mediaType === "video" ? (
                                        <video
                                          src={imagePreviewUrl}
                                          controls
                                          style={{
                                            maxHeight: "160px",
                                            maxWidth: "100%",
                                            borderRadius: "8px",
                                            display: "block",
                                          }}
                                        />
                                      ) : (
                                        <img
                                          src={imagePreviewUrl}
                                          alt="Selected"
                                          style={{
                                            maxHeight: "160px",
                                            maxWidth: "100%",
                                            borderRadius: "8px",
                                            objectFit: "cover",
                                            display: "block",
                                          }}
                                        />
                                      )}
                                      <button
                                        type="button"
                                        onClick={(e) => { e.stopPropagation(); handleImageRemove(); }}
                                        style={{
                                          position: "absolute",
                                          top: "-9px",
                                          right: "-9px",
                                          background: "#ef4444",
                                          border: "none",
                                          borderRadius: "50%",
                                          width: "22px",
                                          height: "22px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          cursor: "pointer",
                                          padding: 0,
                                        }}
                                      >
                                        <FeatherIcon icon="x" size={12} color="#fff" />
                                      </button>
                                      <div style={{ fontSize: "12px", color: "#6b7280", marginTop: "6px" }}>
                                        {uploadFiles[0]?.name}
                                      </div>
                                    </div>
                                  ) : (
                                    <>
                                      <div style={{ display: "flex", justifyContent: "center", gap: "12px" }}>
                                        <FeatherIcon icon="image" size={34} color="#9ca3af" />
                                        <FeatherIcon icon="video" size={34} color="#9ca3af" />
                                      </div>
                                      <div style={{ color: "#6b7280", marginTop: "8px", fontSize: "14px" }}>
                                        Click or drag &amp; drop an image or video here
                                      </div>
                                      <div style={{ color: "#9ca3af", fontSize: "12px", marginTop: "4px" }}>
                                        PNG, JPG, WEBP · MP4, MOV, WEBM · max 16 MB
                                      </div>
                                    </>
                                  )}
                                  <input
                                    ref={imageInputRef}
                                    type="file"
                                    accept="image/*,video/*"
                                    style={{ display: "none" }}
                                    onChange={handleImageSelect}
                                  />
                                </div>

                                <InputCom
                                  labelName="Chat Content"
                                  inputclassName="form-control"
                                  labelClassName="form-Label"
                                  type="textarea"
                                  name="textContent"
                                  onBlur={handleBlur}
                                  value={values.textContent}
                                  onChange={handleChange}
                                  isRequired={true}
                                  invalid={
                                    touched["textContent"] && errors["textContent"]
                                      ? true
                                      : false
                                  }
                                  rowHeight={7}
                                />
                              </Col>

                              {/* Right: WhatsApp-style preview */}
                              <Col lg={5}>
                                <label className="form-Label">Preview</label>
                                <div style={{
                                  borderRadius: "14px",
                                  overflow: "hidden",
                                  boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                                  minHeight: "380px",
                                  display: "flex",
                                  flexDirection: "column",
                                  background: "#e5ddd5",
                                }}>
                                  {/* WhatsApp header bar */}
                                  <div style={{
                                    background: "#075e54",
                                    padding: "10px 14px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                  }}>
                                    <div style={{
                                      width: "36px",
                                      height: "36px",
                                      borderRadius: "50%",
                                      background: "#25d366",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      flexShrink: 0,
                                    }}>
                                      <FeatherIcon icon="user" size={18} color="#fff" />
                                    </div>
                                    <div>
                                      <div style={{ color: "#fff", fontWeight: 600, fontSize: "14px", lineHeight: 1.3 }}>Recipient</div>
                                      <div style={{ color: "#b2dfdb", fontSize: "11px" }}>online</div>
                                    </div>
                                    <div style={{ marginLeft: "auto", display: "flex", gap: "12px" }}>
                                      <FeatherIcon icon="video" size={18} color="#b2dfdb" />
                                      <FeatherIcon icon="phone" size={18} color="#b2dfdb" />
                                    </div>
                                  </div>

                                  {/* Chat body */}
                                  <div style={{
                                    flex: 1,
                                    padding: "12px 10px",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: (imagePreviewUrl || values.textContent) ? "flex-end" : "center",
                                    alignItems: (imagePreviewUrl || values.textContent) ? "flex-end" : "center",
                                  }}>
                                    {(imagePreviewUrl || values.textContent) ? (
                                      <div style={{
                                        background: "#dcf8c6",
                                        borderRadius: "12px 0 12px 12px",
                                        padding: imagePreviewUrl ? "5px 5px 6px 5px" : "10px 12px 6px 12px",
                                        maxWidth: "88%",
                                        boxShadow: "0 1px 2px rgba(0,0,0,0.15)",
                                      }}>
                                        {imagePreviewUrl && mediaType === "video" && (
                                          <video
                                            src={imagePreviewUrl}
                                            controls
                                            style={{
                                              width: "100%",
                                              borderRadius: "8px",
                                              display: "block",
                                              marginBottom: values.textContent ? "6px" : "0",
                                            }}
                                          />
                                        )}
                                        {imagePreviewUrl && mediaType === "image" && (
                                          <img
                                            src={imagePreviewUrl}
                                            alt="preview"
                                            style={{
                                              width: "100%",
                                              borderRadius: "8px",
                                              display: "block",
                                              marginBottom: values.textContent ? "6px" : "0",
                                            }}
                                          />
                                        )}
                                        {values.textContent && (
                                          <div style={{
                                            fontSize: "13px",
                                            color: "#111",
                                            whiteSpace: "pre-wrap",
                                            wordBreak: "break-word",
                                            padding: imagePreviewUrl ? "0 5px" : "0",
                                          }}>
                                            {values.textContent}
                                          </div>
                                        )}
                                        <div style={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                          alignItems: "center",
                                          gap: "3px",
                                          marginTop: "4px",
                                          paddingRight: imagePreviewUrl ? "4px" : "0",
                                        }}>
                                          <span style={{ fontSize: "11px", color: "#8696a0" }}>
                                            {new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
                                          </span>
                                          <FeatherIcon icon="check-circle" size={13} color="#53bdeb" />
                                        </div>
                                      </div>
                                    ) : (
                                      <div style={{ textAlign: "center", color: "#aaa", fontSize: "13px" }}>
                                        <FeatherIcon icon="message-square" size={38} color="#ccc" />
                                        <div style={{ marginTop: "8px" }}>Message preview will appear here</div>
                                      </div>
                                    )}
                                  </div>

                                  {/* Input bar (decorative) */}
                                  <div style={{
                                    background: "#f0f0f0",
                                    padding: "8px 12px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}>
                                    <div style={{
                                      flex: 1,
                                      background: "#fff",
                                      borderRadius: "20px",
                                      padding: "7px 14px",
                                      fontSize: "13px",
                                      color: "#aaa",
                                    }}>
                                      Type a message
                                    </div>
                                    <div style={{
                                      width: "36px",
                                      height: "36px",
                                      borderRadius: "50%",
                                      background: "#25d366",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}>
                                      <FeatherIcon icon="mic" size={16} color="#fff" />
                                    </div>
                                  </div>
                                </div>
                              </Col>
                            </Row>

                            {values.toUserTypes.length > 0 && (
                              <Col lg={12} className="mt-4">
                                <label htmlFor="allMobileNumber" className="form-Label">
                                  To<span className="text-danger ml-05">*</span>
                                </label>
                                
                                <div style={{
                                  border: "1px solid #e0e0e0",
                                  borderRadius: "12px",
                                  padding: "20px",
                                  background: "#ffffff",
                                  boxShadow: "0 2px 8px rgba(0,0,0,0.02)"
                                }}>
                                  {/* Top Bar */}
                                  <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
                                    <div className="d-flex align-items-center">
                                      <div style={{
                                        width: "48px",
                                        height: "48px",
                                        borderRadius: "50%",
                                        background: "#e8f5e9",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        marginRight: "15px",
                                      }}>
                                        <FeatherIcon icon="users" size={22} color="#2e7d32" />
                                      </div>
                                      <div>
                                        <div style={{ fontSize: "16px", fontWeight: 700, color: "#111" }}>
                                          {allMobileNum.length.toLocaleString()} contacts selected
                                        </div>
                                        <div style={{ fontSize: "13px", color: "#666" }}>
                                          {values.toUserTypes.join(', ')} users &bull; All valid numbers
                                        </div>
                                      </div>
                                    </div>
                                    <button
                                      type="button"
                                      onClick={() => setShowContactsDialog(true)}
                                      style={{
                                        border: "1px solid #2e7d32",
                                        color: "#2e7d32",
                                        background: "transparent",
                                        borderRadius: "8px",
                                        padding: "6px 16px",
                                        fontWeight: 600,
                                        fontSize: "13px",
                                        cursor: "pointer",
                                        transition: "all 0.2s"
                                      }}
                                      onMouseEnter={(e) => e.currentTarget.style.background = "#f1f8e9"}
                                      onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
                                    >
                                      View contacts
                                    </button>
                                  </div>

                                  {/* Chips Preview */}
                                  <div className="d-flex flex-wrap gap-2 mb-3">
                                    {allMobileNum.slice(0, 10).map((item: any, index: number) => {
                                      const isMatch = filter && (
                                        item.name?.toLowerCase().includes(filter.toLowerCase()) ||
                                        item.phone.toLowerCase().includes(filter.toLowerCase())
                                      );
                                      return (
                                        <div
                                          key={index}
                                          style={{
                                            background: isMatch ? "#fff9c4" : "#e8f5e9",
                                            color: "#1b5e20",
                                            border: isMatch ? "1px solid #fbc02d" : "1px solid #c8e6c9",
                                            padding: "4px 12px",
                                            borderRadius: "20px",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            fontSize: "13px",
                                            fontWeight: 500,
                                            gap: "6px"
                                          }}
                                        >
                                          <span>{item.name ? `${item.name} - ${item.phone}` : item.phone}</span>
                                          <FeatherIcon
                                            icon="x"
                                            size={14}
                                            style={{ cursor: "pointer", opacity: 0.7 }}
                                            onClick={() => handleRemoveParts(index, setFieldValue)}
                                          />
                                        </div>
                                      );
                                    })}
                                    {allMobileNum.length > 10 && (
                                      <div
                                        style={{
                                          background: "#f5f5f5",
                                          color: "#616161",
                                          border: "1px solid #e0e0e0",
                                          padding: "4px 12px",
                                          borderRadius: "20px",
                                          display: "inline-flex",
                                          alignItems: "center",
                                          fontSize: "13px",
                                          fontWeight: 500
                                        }}
                                      >
                                        +{ (allMobileNum.length - 10).toLocaleString() } more
                                      </div>
                                    )}
                                  </div>

                                  {/* Bottom Actions */}
                                  <div className="d-flex align-items-center justify-content-between pt-3" style={{ borderTop: "1px solid #f0f0f0" }}>
                                    <div>
                                      {!showAddInput ? (
                                        <button
                                          type="button"
                                          onClick={() => setShowAddInput(true)}
                                          style={{
                                            background: "#e8f5e9",
                                            color: "#2e7d32",
                                            border: "none",
                                            padding: "6px 14px",
                                            borderRadius: "8px",
                                            fontWeight: 600,
                                            fontSize: "13px",
                                            cursor: "pointer",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: "6px"
                                          }}
                                        >
                                          <FeatherIcon icon="plus" size={15} /> Add individual number
                                        </button>
                                      ) : (
                                        <div className="d-flex align-items-center gap-2">
                                          <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            style={{ width: "220px", borderColor: "#a5d6a7", fontSize: "13px" }}
                                            placeholder="Enter number & press Enter"
                                            onKeyDown={(e) => {
                                              if (e.key === "Enter" || e.key === "Tab") {
                                                handleMobileAdd(e, setFieldValue);
                                              }
                                            }}
                                            value={text}
                                            onChange={(e: any) => setText(e.target.value)}
                                            autoFocus
                                          />
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-light d-flex align-items-center justify-content-center"
                                            onClick={() => {
                                              setShowAddInput(false);
                                              setText("");
                                            }}
                                            style={{ height: "31px", width: "31px", padding: 0 }}
                                          >
                                            <FeatherIcon icon="x" size={14} />
                                          </button>
                                        </div>
                                      )}
                                    </div>

                                    <button
                                      type="button"
                                      onClick={() => handleClearAll(setFieldValue)}
                                      style={{
                                        background: "transparent",
                                        color: "#d32f2f",
                                        border: "none",
                                        fontWeight: 600,
                                        fontSize: "13px",
                                        cursor: "pointer",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "6px"
                                      }}
                                    >
                                      <FeatherIcon icon="trash-2" size={15} /> Clear all
                                    </button>
                                  </div>
                                </div>
                                <ErrorMessage
                                  name="allMobileNumber"
                                  component={ErrorText}
                                />
                              </Col>
                            )}

                            <Dialog
                              header="Selected Contacts"
                              visible={showContactsDialog}
                              onHide={() => setShowContactsDialog(false)}
                              style={{ width: '500px' }}
                              modal
                              className="p-fluid"
                            >
                              <div className="mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Search contacts..."
                                  value={contactsSearch}
                                  onChange={(e) => setContactsSearch(e.target.value)}
                                  style={{
                                    padding: "8px 12px",
                                    borderRadius: "8px",
                                    border: "1px solid #ced4da",
                                    fontSize: "14px"
                                  }}
                                />
                              </div>
                              <div style={{ maxHeight: "300px", overflowY: "auto", paddingRight: "5px" }}>
                                {allMobileNum
                                  .filter((c: any) => {
                                    const search = (contactsSearch || "").toLowerCase();
                                    return (
                                      (c.name || "").toLowerCase().includes(search) || 
                                      (c.phone || "").toLowerCase().includes(search)
                                    );
                                  })
                                  .map((c: any, idx: number) => (
                                    <div
                                      key={idx}
                                      className="d-flex align-items-center justify-content-between p-2 mb-2"
                                      style={{
                                        background: "#f8f9fa",
                                        borderRadius: "8px",
                                        border: "1px solid #e9ecef"
                                      }}
                                    >
                                      <div>
                                        <div style={{ fontWeight: 600, color: "#2e7d32", fontSize: "14px" }}>
                                          {c.name || "Individual"}
                                        </div>
                                        <div style={{ fontSize: "12px", color: "#6c757d" }}>
                                          {c.phone}
                                        </div>
                                      </div>
                                      <button
                                        type="button"
                                        className="btn btn-sm text-danger"
                                        onClick={() => {
                                          const updated = allMobileNum.filter((_: any, i: number) => i !== idx);
                                          setAllMobilenum(updated);
                                          setFieldValue("allMobileNumber", updated);
                                        }}
                                        style={{ background: "transparent", border: "none" }}
                                      >
                                        <FeatherIcon icon="trash-2" size={16} />
                                      </button>
                                    </div>
                                  ))
                                }
                                {allMobileNum.length === 0 && (
                                  <div className="text-center text-muted p-4">No contacts selected</div>
                                )}
                              </div>
                            </Dialog>

                            <div className="d-flex justify-content-end mt-2 align-items-center">
                              {values.scheduledSendTime && (
                                <div className="me-auto text-success fw-bold">
                                  Scheduled for: {new Date(values.scheduledSendTime).toLocaleString()}
                                </div>
                              )}
                              <Button
                                className="secondary-btn me-2"
                                label={"Reset"}
                                type="button"
                                onClick={() => handleReset(resetForm)}
                              />
                              <Button
                                className="btn-warning me-2 text-dark"
                                label={"Schedule Message"}
                                type="button"
                                onClick={() => {
                                  setIsSubmitting(true);
                                  setShowScheduleDialog(true);
                                }}
                              />
                              <Button
                                className="btn-primary me-2 btn-primary-shadow"
                                label={"Send Chat"}
                                type="submit"
                                onClick={() => {
                                  setIsSubmitting(true);
                                  setFieldValue("scheduledSendTime", null);
                                }}
                              />
                            </div>

                            <Dialog 
                              visible={showScheduleDialog} 
                              onHide={() => setShowScheduleDialog(false)} 
                              header="Schedule Message"
                              style={{ width: '400px' }}
                              modal
                              className="p-fluid"
                            >
                              <div className="p-field mt-2">
                                <label htmlFor="scheduledTime" className="form-Label mb-1">Select Date and Time</label>
                                <input 
                                  id="scheduledTime" 
                                  type="datetime-local"
                                  className="form-control"
                                  value={tempScheduledTime} 
                                  onChange={(e: any) => setTempScheduledTime(e.target.value)} 
                                  min={new Date().toISOString().slice(0, 16)}
                                  style={{
                                    padding: "8px 12px",
                                    borderRadius: "4px",
                                    border: "1px solid #ced4da",
                                    fontSize: "14px"
                                  }}
                                />
                              </div>
                              <div className="d-flex justify-content-end mt-4">
                                <Button 
                                  className="secondary-btn me-2" 
                                  label="Cancel" 
                                  type="button" 
                                  onClick={() => setShowScheduleDialog(false)} 
                                />
                                <Button 
                                  className="btn-primary" 
                                  label="Confirm Schedule" 
                                  type="button" 
                                  onClick={() => {
                                    if (tempScheduledTime) {
                                      // Convert local input time to UTC ISO string
                                      const localDate = new Date(tempScheduledTime);
                                      const utcIsoString = localDate.toISOString();
                                      
                                      setFieldValue("scheduledSendTime", utcIsoString);
                                      setShowScheduleDialog(false);
                                      setTimeout(() => {
                                        submitForm();
                                      }, 100);
                                    } else {
                                      showToast("Please select a date and time", { type: "error" });
                                    }
                                  }} 
                                />
                              </div>
                            </Dialog>
                          </Row>
                        </Form>
                      );
                    }}
                  </Formik>
                </React.Fragment>
              </CardBody>
            </Card>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SendWhatsAppMessage;
